import React from 'react'
import { FormCheck } from 'atoms/Inputs'

export const selectionFormatter = (cellContent, row, rowIndex, formatExtraData) => {
  const { allowEdit, field, fn } = formatExtraData

  return (
    <FormCheck
      value={!!row[field]}
      allowEdit={typeof allowEdit != 'boolean' ? allowEdit(row) : allowEdit}
      fn={() => fn(row, field, rowIndex)}
    />
  )
}
